import React from "react";
// import PropTypes from 'prop-types'
import { AddressInfoStyled } from "./styled";
import { useTranslation } from "react-i18next";

const AddressInfo = ({ address_en, address_th, google_map_url }) => {
  const { i18n, t } = useTranslation(["common", "room"]);
  return (
    <AddressInfoStyled>
      <div className="address_title">{t("Address", { ns: "room" })}</div>
      <div className="address_detail">
        {i18n.language === "en" ? address_en : address_th}
      </div>
      <a
        className="address_map"
        href={google_map_url || ""}
        target="_blank"
        rel="noreferrer"
      >
        Google Map: {google_map_url}
      </a>
    </AddressInfoStyled>
  );
};

AddressInfo.propTypes = {};

export default AddressInfo;
